module.exports = __webpack_public_path__ + "static/media/HTML and CSS.f2f231b3.pdf";